"use client";

import React from "react";
import { startBugsnag, getErrorBoundary } from "@/lib/bugsnag";

startBugsnag();
const ErrorBoundary = getErrorBoundary();

const ErrorFallback = () => (
    <div className="flex h-screen w-full items-center justify-center bg-background text-foreground">
        <div className="text-center">
            <h2 className="text-2xl font-bold">Oops, something went wrong!</h2>
            <p className="mt-2 text-muted-foreground">
                We have already received a report and are working on a fix.
            </p>
        </div>
    </div>
);

export function BugsnagProvider({ children }: { children: React.ReactNode }) {
    return <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>;
}
